import { Fragment } from "react";

// Brand word: "HO" full-size, "ARD" in smaller caps (~2/3 height).
export const Hoard = ({ className = "" }) => (
  <span className={`whitespace-nowrap ${className}`} data-brand="hoard">HO<span className="text-[0.67em] tracking-wide">ARD</span></span>
);

// Turn any plain string containing "Hoard"/"HOARD" into nodes with the styled brand word.
export const hoardify = (text) => {
  if (typeof text !== "string" || !/hoard/i.test(text)) return text;
  const parts = text.split(/\b(HOARD|Hoard)\b/);
  return parts.map((p, i) => (p === "HOARD" || p === "Hoard" ? <Hoard key={i} /> : <Fragment key={i}>{p}</Fragment>));
};

export default Hoard;
